import { render, staticRenderFns } from "./message.vue?vue&type=template&id=65e77c74&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=65e77c74&prod&scoped=true&lang=less"
import style1 from "./message.vue?vue&type=style&index=1&id=65e77c74&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e77c74",
  null
  
)

export default component.exports